import script from "./returnSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./returnSearch.vue?vue&type=script&setup=true&lang=js"

import "./returnSearch.vue?vue&type=style&index=0&id=59ce1d17&lang=less"

const __exports__ = script;

export default __exports__